<template>
  <div 
    ref="imgRef"
    class="ob-image"
    :class="round ? 'round' : ''"
    :style="{
      ...style,
    }"
  >
    <svg-icon name="icon-live" v-if="showLiveImg"></svg-icon>
    <img
      v-if="showImg"
      class="origin-image"
      :style="{ 
        opacity: originOpacity, 
        transition: `${duration}ms`,
        objectFit: fit,
        ...style,
      }"
      :data-targetsrc="srcObj.src ? '' : src"
      :class="round ? 'round' : ''"
      ref="originImgRef" 
      v-bind="{
        ...srcObj
      }"
      @load="onLoad"
      @error="onError"
    />
  </div>

</template>

<script setup>

const props = defineProps({
  src: {
    type: String,
    default: ''
  },
  fit: {
    type: String,
    default: 'cover'
  },
  formatWidth: {
    type: [String, Number],
    default: ''
  },
  formatHeight: {
    type: [String, Number],
    default: ''
  },
  round: {
    type: [String, Boolean],
    default: false
  },
  errorImg: {
    type: String,
    default: ''
  },
  lazy: {
    type: Boolean,
    default: false
  },
  transToCloud: {
    type: Boolean,
    default: true
  },
  showLiveImg:{
    type: Boolean,
    default: false
  },
  style: {
    type: Object,
    default: () => {}
  },
  stopWatch: {
    type: Boolean,
    default: true
  },
  imgBackColor: {
    type: String,
    default: 'transparent'
  },
  crop: {
    type: String,
    default: ''
  },
  fetchpriority: {
    type: String,
    default: 'auto'
  },
  duration: {
    type: Number,
    default: 100
  }
})


const { proxy } = getCurrentInstance()

const imgRef = ref(null)
const originImgRef = ref(null)
const showImg = ref(true)
const orginLoaded = ref(false)

const srcObj = ref({})

const originOpacity = computed(() => {
  return orginLoaded.value ? 1 : 0;
})


// 监听视频容器是否在视觉窗口内，不在则暂停视频播放
const ioInstance = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    const { target } = entry
    if (entry.isIntersecting) {
      target.src = proxy.$formatImg(props.src, props.formatWidth, props.formatHeight)
      target.dataset.src && target.attributes.removeNamedItem('data-src')
      ioInstance.unobserve(target)
    }
  })
}, {
  root: null,
  rootMargin: '0px',
  threshold: [0.1, 0.5, 1],
})

// 图片懒加载后移除预览图
function onLoad () {
  imgRef.value && (imgRef.value.style.backgroundColor = 'transparent')
  originImgRef.value && (originImgRef.value.style.backgroundColor = 'transparent')
  orginLoaded.value = true
}

// 图片出错展示错误图或者重新请求原图
function onError (e) {
  imgRef.value && (imgRef.value.style.backgroundColor = 'var(--color-background-tertiary)')
    originImgRef.value && (originImgRef.value.style.backgroundColor = 'var(--color-background-tertiary)')
}

const stopSetImgPath = watch([props, originImgRef], ([propsDetectValue, imgDom]) => {
  if (imgDom) {
    let { src, lazy, formatWidth, formatHeight, transToCloud, stopWatch, crop } = propsDetectValue
    orginLoaded.value = false
    srcObj.value = {}
    // 处理文件定向到私有桶场景
    if (src?.includes('/ugc/frontend/attachment/view')) {
      try {
        let url = new URL(src)
        // 开发环境需要切换为本地ip代理，链接需要携带appcode给服务端校验
        if (import.meta.env.VITE_ENV === 'DEV') {
          src = `${location.origin}${url.pathname.includes('proxy') ? '' : '/proxy'}${url.pathname}${url.search}${url.search.includes('appCode') ? '' : `${src.includes('?') ? '&' : '?'}appCode=community&t=${Date.now()}`}` 
        } else {
          src = `${src}${src.includes('?') ? '&' : '?'}appCode=community&t=${Date.now()}`
        }
      } catch {}
    }
    if (lazy) {
      srcObj.value['data-src'] = transToCloud ? proxy.$formatImg(src, formatWidth, formatHeight, true, crop) : src
      ioInstance.observe(originImgRef.value)
    } else {
      srcObj.value.src = transToCloud ? proxy.$formatImg(src, formatWidth, formatHeight, true, crop) : src
    }
    // srcObj.value.origin = src
    stopWatch && stopSetImgPath()
  }
}, {
  immediate: true,
  deep: true
})



</script>

<style lang="postcss" scoped>
.ob-image {
  position: relative;
  background-color: transparent;
  user-select: none;
  -webkit-user-select: none;
  line-height: 0!important;
  background-color: var(--color-background-tertiary);
  width: fit-content;
  &:empty {
    background-color: var(--color-background-tertiary);
  }
  .icon-live{
    position: absolute;
    z-index: 10;
    top: 4px;
    left: 4px;
    width: 24px;
    height: 24px;
  }
  @media screen and (max-width: 1023px) {
    .icon-live{
      width: 18px;
      height: 18px;
    }
  }

  .origin-image {
    /* position: absolute;
    top: 0;
    left: 0; */
    width: 100%;
    height: 100%;
    min-width: 10px;
    min-height: 10px;
    object-position: top;
  }
}
.round {
  border-radius: 50%;
}
</style>